import PropTypes from 'prop-types';
import styled from 'styled-components';

const TagLink = styled.a`
  color: ${props => props.theme.colorBlack};
  font-size: ${props => props.theme.fontSizeSmall};
`;

const PostTags = ({ tags, onClick }) => {
  if (tags.length === 0) return null;

  const renderTagElement = (tag) => {
    const tagName = tag.name || tag.shortName;
    return (
      <TagLink
        className="button-tag"
        href={`/tag/${tag.slug}`}
        onClick={e => {
          e.preventDefault();
          onClick(tag.slug);
          // delay redirection to be able to send tracking event
          setTimeout(() => {
            window.location.href = `/tag/${tag.slug}`;
          }, 100);
        }}
      >
        {tagName}
      </TagLink>
    );
  };

  return (
    <ul className="button-tags">
      {tags.map(tag => (
        <li key={tag.slug}>{ renderTagElement(tag) }</li>
      ))}
    </ul>
  );
};

PostTags.propTypes = {
  tags: PropTypes.array,
  onClick: PropTypes.func,
};

PostTags.defaultProps = {
  tags: [],
  onClick: () => {},
};

export default PostTags;
